module.exports = __webpack_public_path__ + "img/topo-palavras.f522ac7f.png";